<template>
  <div class="common-contact-info">
    <b-row class="mt-3">
      <!--Address-->
      <b-col
        sm="6"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.phone')} *`"
          :state="!errors.has($tc('global.phone'))"
          :invalid-feedback="errors.first($tc('global.phone'))"
        >
          <vt-input
            v-model="data.mainPhone"
            v-validate="'required|min:9|max:9'"
            type="number"
            :name="$tc('global.phone')"
            class="form-control-sm"
            :class="{'is-invalid': errors.has($tc('global.phone')) }"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="6"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.phone')} 1`"
          :state="!errors.has(`${$tc('global.phone')}1`)"
          :invalid-feedback="errors.first(`${$tc('global.phone')}1`)"
        >
          <vt-input
            v-model="data.otherPhone1"
            v-validate="'min:9|max:9'"
            type="number"
            :name="`${$tc('global.phone')}1`"
            class="form-control-sm"
            :class="{'is-invalid': errors.has(`${$tc('global.phone')}1`) }"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="6"
        md="4"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('global.phone')} 2`"
          :state="!errors.has(`${$tc('global.phone')}2`)"
          :invalid-feedback="errors.first(`${$tc('global.phone')}2`)"
        >
          <vt-input
            v-model="data.otherPhone2"
            v-validate="'min:9|max:9'"
            type="number"
            :name="`${$tc('global.phone')}2`"
            class="form-control-sm"
            :class="{'is-invalid': errors.has(`${$tc('global.phone')}2`) }"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="6"
        md="6"
        lg="4"
      >
        <b-form-group
          :label="`${$tc('global.email')} *`"
          :state="!errors.has($tc('global.email'))"
          :invalid-feedback="errors.first($tc('global.email'))"
        >
          <vt-input
            v-model="data.email"
            v-validate="'required'"
            :name="$tc('global.email')"
            class="form-control-sm"
            :class="{'is-invalid': errors.has($tc('global.email')) }"
          />
        </b-form-group>
      </b-col>
      <b-col
        sm="6"
        md="6"
        lg="2"
      >
        <b-form-group
          :label="`${$tc('login.phpd')} *`"
          :state="!errors.has($tc('login.phpd'))"
          :invalid-feedback="errors.first($tc('login.phpd'))"
        >
          <vt-input
            v-model="data.emailPass"
            v-validate="'required'"
            type="password"
            :name="$tc('login.phpd')"
            class="form-control-sm"
            :class="{'is-invalid': errors.has($tc('login.phpd')) }"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
    name: 'CommonContactInfo',
    inject: ['formValidator'],
    props: {
        data: { type: Object, required: false }
    },
    data() {
        return {}
    },
    computed: {},
    created() {
        this.$validator = this.formValidator
    }
}

</script>
